module.exports = __webpack_public_path__ + "static/media/primeicons.b29a888f.ttf";